import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { QzTrayPayloadDTO, TicketPrintPermissionDTO } from "../../../types/qztray/QzTrayTypes";

/**
 * 🖨️ QzTrayPrintState
 *
 * Estado global del flujo de impresión QZ Tray.
 * Controla el modal, la venta/compra asociada y el payload generado.
 */
interface QzTrayPrintState {
  showModal: boolean;
  permission: TicketPrintPermissionDTO;
  payload: QzTrayPayloadDTO | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: QzTrayPrintState = {
  showModal: false,
  permission: {
    id: null,
    type: null,          
    allowPrint: false,
  },
  payload: null,
  isLoading: false,
  error: null,
};

const qzTrayPrintSlice = createSlice({
  name: "qzTrayPrint",
  initialState,
  reducers: {
    // 🟢 Mostrar u ocultar el modal de impresión
    setShowModal(state, action: PayloadAction<boolean>) {
      state.showModal = action.payload;
    },

    // 🧾 Guardar la información del permiso (id, type y flag)
    setPrintPermission(state, action: PayloadAction<TicketPrintPermissionDTO>) {
      state.permission = action.payload;
    },

    // 🧱 Guardar el payload completo recibido del backend
    setPrintPayload(state, action: PayloadAction<QzTrayPayloadDTO | null>) {
      state.payload = action.payload;
    },

    // 🔄 Cambiar estado de carga
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },

    // ❌ Manejar errores
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },

    // 🧹 Reiniciar todo el estado del módulo de impresión
    resetQzTrayPrintState(state) {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setShowModal,
  setPrintPermission,
  setPrintPayload,
  setLoading,
  setError,
  resetQzTrayPrintState,
} = qzTrayPrintSlice.actions;

export default qzTrayPrintSlice.reducer;
